"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CTAsWrapper = exports.FeatureMedia = exports.FeatureMediaColumn = exports.RegularText = exports.StrikeThroughText = exports.FeaturePanelFlex = exports.ContentWrapper = exports.FeaturePanelGrid = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _styledSystem = require("styled-system");

var _Media = _interopRequireDefault(require("../Media"));

var _Layout = require("../Layout");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var FeaturePanelGrid = (0, _styled.default)(_Layout.Grid)(function (_ref) {
  var image = _ref.image,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      featurePanels = _ref$theme.featurePanels;
  var style = {
    overflow: image ? 'initial' : 'hidden',
    alignItems: 'center',
    justifyContent: 'center'
  };
  return (0, _styledSystem.variant)({
    variants: {
      primary: _objectSpread({}, style),
      secondary: _objectSpread(_objectSpread({}, style), {}, {
        margin: 0,
        padding: 'base',
        background: colors[featurePanels.backgroundColorSecondary]
      }),
      tertiary: _objectSpread(_objectSpread({}, style), {}, {
        background: colors[featurePanels.backgroundColorTertiary]
      })
    }
  });
});
exports.FeaturePanelGrid = FeaturePanelGrid;
var ContentWrapper = (0, _styled.default)(_rebass.Flex)(function (_ref2) {
  var featurePanels = _ref2.theme.featurePanels;
  var style = {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    paddingBottom: ['base', null, 0],
    paddingTop: ['base', null, 0]
  };
  return (0, _styledSystem.variant)({
    variants: {
      primary: _objectSpread({}, style),
      secondary: _objectSpread(_objectSpread({}, style), {}, {
        paddingTop: featurePanels.contentWrapperPaddingSecondaryY,
        paddingBottom: featurePanels.contentWrapperPaddingSecondaryY,
        paddingLeft: featurePanels.contentWrapperPaddingSecondaryX,
        paddingRight: featurePanels.contentWrapperPaddingSecondaryX
      }),
      tertiary: _objectSpread(_objectSpread({}, style), {}, {
        paddingBottom: ['large', null, 'medium'],
        paddingTop: ['large', null, 'medium'],
        paddingLeft: ['base', null, 'medium'],
        paddingRight: ['base', null, 'medium']
      })
    }
  });
});
exports.ContentWrapper = ContentWrapper;
var FeaturePanelFlex = (0, _styled.default)(_rebass.Flex)(function (_ref3) {
  var featurePanels = _ref3.theme.featurePanels;
  var style = {
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%',
    alignItems: 'center',
    marginTop: featurePanels.buttonMarginTop
  };
  return (0, _styledSystem.variant)({
    variants: {
      primary: _objectSpread({}, style),
      secondary: _objectSpread({}, style),
      tertiary: _objectSpread(_objectSpread({}, style), {}, {
        marginTop: featurePanels.marginTopTertiary
      })
    }
  });
}, function (_ref4) {
  var price = _ref4.price;
  return {
    '>span, >a': {
      marginBottom: price ? '1rem' : '0'
    },
    '>span': {
      marginRight: price ? '1.5rem' : '0'
    }
  };
});
exports.FeaturePanelFlex = FeaturePanelFlex;
var StrikeThroughText = (0, _styled.default)('span')(function (_ref5) {
  var space = _ref5.theme.space;
  return {
    textDecoration: 'line-through',
    marginRight: space.small
  };
});
exports.StrikeThroughText = StrikeThroughText;
var RegularText = (0, _styled.default)('span')({
  fontSize: 'large'
});
exports.RegularText = RegularText;
var FeatureMediaColumn = (0, _styled.default)(_Layout.Column)(function (_ref6) {
  var textPosition = _ref6.textPosition;
  var paddingLocation = textPosition === 'right' ? 'paddingLeft' : 'paddingRight';
  return _defineProperty({
    order: '-1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, _mediaQueries.default.medium, _defineProperty({
    order: textPosition === 'right' ? '-1' : '1'
  }, paddingLocation, '0 !important'));
});
exports.FeatureMediaColumn = FeatureMediaColumn;
var FeatureMedia = (0, _styled.default)(_Media.default)({
  width: '100%'
});
exports.FeatureMedia = FeatureMedia;
var CTAsWrapper = (0, _styled.default)('div')(function (_ref8) {
  var space = _ref8.theme.space;
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: space.large,
    gap: space.base
  };
});
exports.CTAsWrapper = CTAsWrapper;